// Cliente API de Obra Radar. Pega al proxy GATEADO de Orión (/orion/api/radar/*),
// que exige JWT y org_id==rentalmaq (si no, 403). El nginx del dashboard proxya
// /orion/api → Orión. Mismo patrón de auth (Bearer de localStorage) que los demás módulos.

import type { EstadoResumen, EstadoDetalle, PreguntarResp } from './types';

const ORION = '/orion/api';
const BASE = '/radar';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}` };
}

async function asJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${res.status} ${res.statusText} — ${body.slice(0, 200)}`);
  }
  return res.json() as Promise<T>;
}

/** Radar nacional: todos los estados ordenados por demanda. */
export async function getEstados(): Promise<EstadoResumen[]> {
  const res = await fetch(`${ORION}${BASE}/estados`, { headers: authHeaders() });
  const d = await asJson<{ estados: EstadoResumen[] }>(res);
  return d.estados ?? [];
}

/** Deep de un estado: zonas, proyectos, proveedores, contactos, recurrentes. */
export async function getEstado(nombre: string): Promise<EstadoDetalle> {
  const res = await fetch(`${ORION}${BASE}/estado/${encodeURIComponent(nombre)}`, {
    headers: authHeaders(),
  });
  return asJson<EstadoDetalle>(res);
}

/** Pregunta en lenguaje natural con lente de renta de maquinaria.
 *  El motor NL/cognitivo puede tardar; el caller maneja el timeout con gracia. */
export async function preguntar(pregunta: string, estado?: string): Promise<PreguntarResp> {
  const res = await fetch(`${ORION}${BASE}/preguntar`, {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(estado ? { pregunta, estado } : { pregunta }),
  });
  return asJson<PreguntarResp>(res);
}
